import { Box } from "@mui/system";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { RouteParamsProvider } from "../context/RouteParamsProvider";
import { SelectedOptionsProvider } from "../context/SelectedOptionsContext";
import { Analytics } from "@vercel/analytics/react";

import "./index.css";
import styles from "./app.module.scss";

import { WrapperUI } from "../components/WrapperUI";

const theme = createTheme({
  typography: {
    fontFamily:
      '"Onest", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
    color: "#282823",
  },
  // Extra safety: reinforce on <body> via CssBaseline
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily:
            '"Onest", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
        },
      },
    },
  },
  borderRadius: {
    default: "8px 8px 8px 8px",
    small: "6px 6px 6px 6px",
    medium: "14px 14px 14px 14px",
    big: "20px 20px 20px 20px",
  },
  palette: {
    companyColors: {
      neutral: "#ffffff",
      neutralRGB: "255,255,255",
      primary: "#56585e",
      secondary: "#3e4c6d",
      secondaryRGB: "62,76,109",
      accent: "#cefe5c",
      black: "#18181A",
      greyLight1: "#A3A3A0",
      greyLight2: "#D9D9D9",
      greyLight3: "#eaeaea",
      greyLight4: "#eee",
      greyLight5: "#f3f3f3",
      darkGrey: "#282823",
      opacity0: 0,
      opacity25: 0.25,
      opacity50: 0.5,
      opacity75: 0.75,
    },
  },
});

export function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Analytics />
      <SelectedOptionsProvider>
        <Box className={styles.app}>
          <Router>
            <Routes>
              <Route
                path="/"
                element={
                  <RouteParamsProvider>
                    <WrapperUI />
                  </RouteParamsProvider>
                }
              />
              <Route
                path="/:configCode"
                element={
                  <RouteParamsProvider>
                    <WrapperUI />
                  </RouteParamsProvider>
                }
              />
            </Routes>
          </Router>
        </Box>
      </SelectedOptionsProvider>
    </ThemeProvider>
  );
}

export default App;
